var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDamageLocationCarYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 236,
    viewBox: "0 0 120 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_7919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.8006 0.851562C82.9506 1.26156 98.9006 4.91156 103.081 13.2016C107.261 21.4916 108.941 40.6916 108.131 60.0716C107.321 79.4416 104.131 190.352 103.841 197.252C103.551 204.152 103.961 220.392 93.9806 227.122C85.6806 232.752 74.7206 235.012 59.6306 235.012C44.5406 235.012 33.5806 232.752 25.2806 227.122C15.3006 220.392 15.7606 204.152 15.4206 197.252C15.0706 190.352 11.8806 79.4416 11.1306 60.0716C10.3806 40.7016 12.0606 21.5016 16.1806 13.2016C20.2806 4.91156 36.3006 1.26156 38.4506 0.851562H80.8106H80.8006Z",
    fill: "#FFE900",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3008 84.8992C15.3008 83.8592 23.1308 97.5392 26.0908 118.249C28.2408 133.789 28.9308 159.489 27.3708 168.949C24.7608 184.669 18.1408 191.399 18.1408 187.979C18.1408 182.589 15.3008 85.9492 15.3008 84.9092V84.8992Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3906 101.609C26.3906 101.609 31.0306 113.149 32.2506 144.939C33.0006 163.789 31.5006 174.459 30.1006 179.099",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3908 195.52C23.7808 209.21 25.4608 222.9 26.1008 225.33",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3801 26.8984C15.3001 33.9184 16.8101 46.0384 19.8901 66.3384",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.639 213.61C69.139 213.69 78.549 211.86 87.319 208.21C89.339 207.32 91.009 205.8 92.079 203.87C93.149 201.94 93.559 199.72 93.239 197.54C92.949 195.57 92.539 193.36 92.139 191.39C90.919 185.53 88.719 177.41 88.719 177.41C88.719 177.41 80.649 180.72 59.649 180.72C38.649 180.72 30.579 177.41 30.579 177.41C30.579 177.41 28.379 185.53 27.159 191.39C26.749 193.36 26.349 195.57 26.059 197.54C25.749 199.72 26.149 201.94 27.219 203.87C28.289 205.8 29.959 207.32 31.979 208.21C40.749 211.85 50.159 213.69 59.659 213.61H59.639Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.968 84.8992C103.968 83.8592 96.1383 97.5392 93.1783 118.249C91.0283 133.789 90.3383 159.489 91.8983 168.949C94.5083 184.669 101.128 191.399 101.128 187.979C101.128 182.589 103.968 85.9492 103.968 84.9092V84.8992Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8882 101.609C92.8882 101.609 88.2482 113.149 87.0282 144.939C86.2782 163.789 87.7782 174.459 89.1782 179.099",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5013 62.3394C98.9213 56.7694 82.6113 6.18938 80.1813 4.33938C77.7413 2.47938 65.6713 1.60938 59.6413 1.60938C53.6113 1.60938 41.2512 2.76937 39.1012 4.33938C36.9512 5.90938 20.3612 56.7794 19.7812 62.3394",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.59 28.0612C101.18 29.5112 101.3 22.9012 92.6005 17.3312C87.0305 13.7312 84.3005 13.6212 84.3005 13.6212L81.9805 7.53125C81.9805 7.53125 93.4705 10.4312 99.1005 15.9412C102.99 19.7712 102.47 24.7012 101.59 28.0612Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6792 28.0612C18.0292 29.5112 17.9692 22.9012 26.6692 17.3312C32.1792 13.7312 34.9692 13.6212 34.9692 13.6212L37.2892 7.53125C37.2892 7.53125 25.7992 10.4312 20.1692 15.9412C16.2192 19.7712 16.7992 24.7012 17.6692 28.0612H17.6792Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6484 194.121C96.0184 207.401 93.8084 222.891 93.1684 225.331",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.97 202.301C101.42 204.391 101.65 211.761 99.9703 215.991C98.2903 220.221 93.2403 227.531 84.8203 229.391C76.4103 231.251 65.0903 231.251 59.6403 231.251C54.1903 231.251 42.8103 231.251 34.4603 229.391C26.1003 227.531 20.9403 220.171 19.3203 215.991C17.7003 211.811 17.8703 204.391 15.3203 202.301",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.89 26.8984C103.97 33.9184 102.34 46.0384 99.2695 66.3384",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.23 112.222C105.82 114.772 105.77 122.202 105.77 123.942C105.77 125.682 108.27 123.012 108.44 118.202C108.61 113.392 106.58 109.672 106.23 112.232V112.222Z",
    fill: "#337AB7",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.789 80.9609L104.019 86.9909H107.729C109.319 88.5409 111.049 89.9409 112.889 91.1709C113.409 91.5209 115.149 92.7409 116.259 93.0309C117.359 93.3209 118.409 92.5109 118.409 91.9309C118.409 91.3509 117.369 89.1509 115.629 86.4809C113.889 83.8109 109.999 83.5209 108.489 83.6409C108.489 83.6409 106.579 81.2009 103.789 80.9709V80.9609Z",
    fill: "#337AB7",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.57 86.8718C107.57 86.8718 112.56 91.1018 114.71 92.4418C116.86 93.7718 118.54 93.1418 118.42 91.9218C118.3 90.7018 116.5 89.1418 111.98 87.8018C108.5 86.8118 107.57 86.8718 107.57 86.8718Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4794 80.9609L15.2494 86.9909H11.5394C9.94938 88.5409 8.21938 89.9409 6.37937 91.1709C5.85938 91.5209 4.11938 92.7409 3.00938 93.0309C1.90938 93.3209 0.859375 92.5109 0.859375 91.9309C0.859375 91.3509 1.89937 89.1509 3.64937 86.4809C5.38937 83.8109 9.27938 83.5209 10.7894 83.6409C10.7894 83.6409 12.6994 81.2009 15.4894 80.9709L15.4794 80.9609Z",
    fill: "#337AB7",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7115 86.8718C11.7115 86.8718 6.72152 91.1018 4.57152 92.4418C2.42152 93.7718 0.741519 93.1418 0.861519 91.9218C0.981519 90.7018 2.77152 89.1418 7.30152 87.8018C10.7815 86.8118 11.7115 86.8718 11.7115 86.8718Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0404 112.222C13.4504 114.772 13.5004 122.202 13.5004 123.942C13.5004 125.682 11.0004 123.012 10.8304 118.202C10.6604 113.392 12.6904 109.672 13.0304 112.232L13.0404 112.222Z",
    fill: "#337AB7",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5219 229.219C33.5219 229.219 29.9219 231.999 24.2419 228.579C18.5519 225.159 16.7019 220.229 15.9419 211.699C15.7719 209.839 15.5319 203.639 15.4219 201.719C15.4219 201.719 16.7019 203.579 17.6819 208.449C18.3819 212.049 18.7219 215.639 20.9319 219.179C26.3819 227.939 33.5219 229.219 33.5219 229.219Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6311 229.271C85.6311 229.271 89.2311 232.051 94.9111 228.571C100.601 225.091 102.511 220.281 103.271 211.691C103.391 209.891 103.681 203.681 103.731 201.711C103.731 201.711 102.511 203.621 101.521 208.501C100.821 212.101 100.481 215.641 98.2711 219.231C92.8211 227.991 85.6211 229.271 85.6211 229.271H85.6311Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4102 134.839L27.1402 132.289",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.871 134.839L92.1406 132.289",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3999 100.331C82.6699 100.331 92.2399 103.641 92.2399 103.641C94.0999 99.5808 100.25 68.4308 99.6699 62.8008C99.6699 62.8008 84.2899 52.3008 59.3999 52.3008C34.5099 52.3008 19.4199 62.8008 19.4199 62.8008C18.8399 68.4308 25.2199 99.5708 27.0799 103.641C27.0799 103.641 36.1299 100.331 59.3999 100.331Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.52 4.57031C64.86 4.60031 70.19 4.97031 75.48 5.67031C75.93 5.70031 76.37 5.86031 76.74 6.13031C77.11 6.40031 77.4 6.76031 77.57 7.18031L78.56 9.85031C78.61 9.95031 78.62 10.0603 78.6 10.1603C78.58 10.2703 78.53 10.3603 78.45 10.4403C78.37 10.5203 78.28 10.5703 78.17 10.5903C78.06 10.6103 77.95 10.5903 77.86 10.5503C71.79 9.61031 65.66 9.09031 59.52 8.98031C53.4 9.08031 47.29 9.61031 41.24 10.5503C41.14 10.6003 41.03 10.6103 40.93 10.5903C40.82 10.5703 40.73 10.5203 40.65 10.4403C40.57 10.3603 40.52 10.2703 40.5 10.1603C40.48 10.0503 40.5 9.94031 40.54 9.85031L41.53 7.18031C41.7 6.76031 41.99 6.39031 42.36 6.13031C42.73 5.86031 43.17 5.71031 43.62 5.67031C48.89 4.97031 54.2 4.60031 59.52 4.57031Z",
    fill: "#193A56",
    stroke: "#193A56",
    strokeWidth: 1.61,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_7919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.27,
    height: 235.86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamageLocationCarYellow);
export default __webpack_public_path__ + "static/media/damage-location-car-yellow.9215f363574b3b8eddadb61583ccdda5.svg";
export { ForwardRef as ReactComponent };